export const nameUrlUtils = {
  // Convert a name to a URL-friendly slug
  convertNameToUrl: (name) => {
    if (!name) return '';

    return String(name)
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  },

  // Convert a URL slug back to a readable name
  convertUrlToName: (urlSegment) => {
    if (!urlSegment) return '';

    return String(urlSegment)
      .split('-')
      .filter(Boolean)
      .join(' ');
  },

  convertUrlfromSearch: (productName) => {
    return nameUrlUtils.convertNameToUrl(productName);
  },
};